import React, { useState, Fragment } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, Field } from 'redux-form';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import TelegramIcon from '@mui/icons-material/Telegram';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { Options } from '../../_utils/_constants';
import { SelectInput, TextInput, AddButton, CardElement, Dragable, Modal, StatusChip, EmptyState } from '../../_Components';

const header = [
    {
        label: 'Подпись',
        width: '40%',
        value: 'fieldComponent'
    },
    {
        label: 'Значение из поля',
        width: '50%',
        value: 'valueComponent'
    },
    {
        label: '',
        width: '10%'
    }
];

const dataArray = (data, project, activeNodekey) => {
    const rows = (data || []).map((item, key) => ({
        key: key + 1,
        fieldComponent: (
            <Field
                name={`template[${activeNodekey}].fields[${key}].field`}
                required={true}
                component={TextInput}
                style={{ width: '100%' }}
            />
        ),
        valueComponent: (
            <Field
                name={`template[${activeNodekey}].fields[${key}].value`}
                component={SelectInput}
                options={((project && project.fields) || []).map((item) => ({ id: item.value, name: item.label }))}
                style={{ width: '100%' }}
            />
        ),
        ...item
    }));
    return rows;
};

const NewTamplateForm = () => (
    <div className="pc-fgrid">
        <Field name="name" required={true} component={TextInput} label="Название" />
        <Field name="type" required={true} component={SelectInput} options={Options.TempateTypeOptions} label="Канал" />
    </div>
);

const fieldCaption = (fields, id) => {
    if (!id) return '—';
    const item = (fields || []).find((entry) => entry.value === id);
    return item ? item.label : id;
};

const Tamplates = ({ formValues, project, change }) => {
    const template = (formValues && formValues.template) || [];
    const [activeNodekey, setActiveNodekey] = useState(template.length > 0 ? 0 : null);
    const [open, setOpen] = useState(false);
    const projectFields = (project && project.fields) || [];
    const smtpSenders = ((project && project.settings && project.settings.email) || []).map((item) => ({
        id: item._id,
        name: item.name || item.sender || item.user
    }));
    const current = activeNodekey != null ? template[activeNodekey] : null;

    const setActive = (index) => {
        setActiveNodekey(index);
    };

    const addTemplate = (item) => {
        const next = [...template, { ...item, fields: [] }];
        change('template', next);
        setActiveNodekey(next.length - 1);
        setOpen(false);
    };

    const openNewTamplateDialog = () => {
        setOpen(!open);
    };

    const sort = (fields) => {
        change(`template[${activeNodekey}].fields`, fields);
    };

    const removeItem = (key) => {
        const fields = (template[activeNodekey] && template[activeNodekey].fields) || [];
        change(`template[${activeNodekey}].fields`, fields.filter((_, index) => index !== key));
    };

    const addItem = () => {
        const fields = (template[activeNodekey] && template[activeNodekey].fields) || [];
        change(`template[${activeNodekey}].fields`, [...fields, {}]);
    };

    return (
        <div className="pc-fill">
            <div className="pc-split pc-split--tpl">
                <CardElement
                    fill
                    title="Шаблоны"
                    subheader={<StatusChip tone="mono">{template.length}</StatusChip>}
                    action={<AddButton handleAddClick={openNewTamplateDialog} label="Новый" variant="contained" />}
                    content={(
                        <div className="pc-panel-body">
                            <div className="pc-tblwrap">
                                {template.map((item, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        className={`pc-listbtn${index === activeNodekey ? ' is-cur' : ''}`}
                                        onClick={() => setActive(index)}
                                    >
                                        {item.type === 'telegram'
                                            ? <TelegramIcon sx={{ fontSize: 16, color: 'var(--muted-2)' }} />
                                            : <MailOutlineIcon sx={{ fontSize: 16, color: 'var(--muted-2)' }} />}
                                        <span className="pc-listbtn__t">{item.name}</span>
                                        <span className="pc-listbtn__n">{(item.fields || []).length}</span>
                                    </button>
                                ))}
                                {template.length === 0 && (
                                    <EmptyState title="Нет шаблонов" description="Создайте шаблон письма или сообщения в Telegram." />
                                )}
                            </div>
                        </div>
                    )}
                />
                <CardElement
                    fill
                    title={current ? current.name : '—'}
                    content={current ? (
                        <div className="pc-panel-body">
                            <div className="pc-tblwrap">
                                <div className="pc-sect">
                                    <div className="pc-fgrid pc-fgrid--3">
                                        <Field
                                            name={`template[${activeNodekey}].name`}
                                            required={true}
                                            component={TextInput}
                                            label="Название"
                                        />
                                        <Field
                                            name={`template[${activeNodekey}].type`}
                                            component={SelectInput}
                                            label="Канал"
                                            options={Options.TempateTypeOptions}
                                        />
                                        <Field
                                            name={`template[${activeNodekey}].subject`}
                                            component={SelectInput}
                                            label="Тема письма из поля"
                                            options={projectFields.map((item) => ({ id: item.value, name: item.label }))}
                                        />
                                        {current.type === 'email' && (
                                            <Field
                                                name={`template[${activeNodekey}].senderEmail`}
                                                component={SelectInput}
                                                label="Отправитель"
                                                options={smtpSenders}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="pc-split" style={{ gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: 0, height: 'auto', minHeight: 0 }}>
                                    <div className="pc-sect">
                                        <div className="pc-sect__t">Строки сообщения</div>
                                        <Dragable
                                            header={header}
                                            rows={dataArray(current.fields, project, activeNodekey)}
                                            edit={false}
                                            sort={sort}
                                            remove={true}
                                            removeFunc={removeItem}
                                        />
                                        <AddButton handleAddClick={addItem} label="Добавить строку" style={{ marginTop: 10 }} />
                                    </div>
                                    <div className="pc-sect" style={{ borderLeft: '1px solid var(--line-2)' }}>
                                        <div className="pc-sect__t">Как придёт сообщение</div>
                                        <div className="pc-msg">
                                            <div className="pc-msg__h">
                                                {current.type === 'telegram' ? 'Заголовок' : 'Тема письма'}
                                                {': '}
                                                <b>{fieldCaption(projectFields, current.subject)}</b>
                                            </div>
                                            <div className="pc-msg__b">
                                                {(current.fields || []).length === 0
                                                    ? 'Строк пока нет'
                                                    : (current.fields || []).map((row, index) => (
                                                        <Fragment key={index}>
                                                            {row.field || 'Подпись'}
                                                            {': '}
                                                            <span>{fieldCaption(projectFields, row.value)}</span>
                                                            <br />
                                                        </Fragment>
                                                    ))}
                                            </div>
                                        </div>
                                        <div className="pc-note pc-note--in" style={{ marginTop: 11 }}>
                                            <InfoOutlinedIcon sx={{ fontSize: 16, mt: '1px' }} />
                                            <span>Подставляются значения из карточки на момент отправки. Пустые поля в сообщение не попадают.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <EmptyState title="Шаблон не выбран" description="Выберите шаблон слева или создайте новый." />
                    )}
                />
            </div>
            {open && (
                <Modal
                    width={480}
                    title="Новый шаблон"
                    open={open}
                    handleSaveClick={addTemplate}
                    handleCloseClick={openNewTamplateDialog}
                    fields={<NewTamplateForm />}
                    initial={{ type: 'email' }}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return {
        formValues,
        isLoading: !!fetch.loading
    };
};

export default compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
    }),
)(Tamplates);
